import { CONVERSATION_FACTS_MEASURES } from 'cube/constants'

import { CubeQuery } from '@driftt/dds.reports'

/**
 * Base cube query for median conversation length defined as the duration between the first interaction and first close in seconds.
 */
export const MedianConversationLengthBaseQuery: CubeQuery = {
  name: 'MedianConversationLength',
  queryName:
    CONVERSATION_FACTS_MEASURES.MEDIAN_DURATION_BETWEEN_FIRST_INTERACTION_AND_FIRST_CLOSE_SECONDS,
  query: {
    measures: [
      CONVERSATION_FACTS_MEASURES.MEDIAN_DURATION_BETWEEN_FIRST_INTERACTION_AND_FIRST_CLOSE_SECONDS,
    ],
  },
}
